import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ReviewPage from "../pages/review/page";
import ShippingPage from "../pages/shipping/page";
import CouponPage from "../pages/coupon/page";
import WarehousePage from "../pages/warehouse/page";
import BestSpreadsheetPage from "../pages/best-spreadsheet/page";
import TipsPage from "../pages/tips/page";
import BeginnersPage from "../pages/beginners/page";
import FindsPage from "../pages/finds/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/sugargoo-spreadsheet-guide", element: <ArticlePage /> },
  { path: "/sugargoo-review", element: <ReviewPage /> },
  { path: "/sugargoo-shipping-guide", element: <ShippingPage /> },
  { path: "/sugargoo-coupon-guide", element: <CouponPage /> },
  { path: "/sugargoo-warehouse-guide", element: <WarehousePage /> },
  { path: "/best-sugargoo-spreadsheet", element: <BestSpreadsheetPage /> },
  { path: "/sugargoo-spreadsheet-tips", element: <TipsPage /> },
  { path: "/sugargoo-spreadsheet-beginners", element: <BeginnersPage /> },
  { path: "/sugargoo-product-finds", element: <FindsPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;